import React, { FunctionComponent } from "react";
import styles from "./Employees.module.scss";
import EmployeesContent from "./EmployeesContent.model";

import combineClasses from "helpers/combine-classes";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import Employee from "./components/Employee/Employee";
import formatDynamicTextColor from "blocks/helpers/formatDynamicTextColor";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";

const Employees: FunctionComponent<EmployeesContent> = (props) => {
    const processedHeadline = getProcessedRichtext(formatDynamicTextColor(props.content.headline));
    const processedBodyText = getProcessedRichtext(props.content.bodyText);
    const wrapperStyles = getWrapperStyles(props.settings);

    return (
        <section className={combineClasses([styles.wrapper, ...wrapperStyles])}>
            <div className={styles.container}>
                {/* Intro */}
                {props.content.headline || processedBodyText ?
                    <div className={styles.intro}>
                        {/* Headline */}
                        <DynamicHeading className={styles.headline} headlineSize={props.content.headlineSize} headlineWeight={props.content.headlineWeight} innerHtml={processedHeadline}></DynamicHeading>

                        {/* Body Text */}
                        {processedBodyText ? <div className={styles.text} dangerouslySetInnerHTML={processedBodyText}></div> : null}
                    </div> : null}

                {/* Employees */}
                {props.content.employees && props.content.employees.length > 0 ?
                    <div className={styles.grid}>
                        {props.content.employees.map(item => {
                            return (
                                <Employee key={item.contentUdi} {...item} />
                            );
                        })}
                    </div> : null}
            </div>
        </section>
    );
};

export default Employees;